import { createContext } from "react";

//holds variables for Context(). Variables sourced from src/layout/Layout.js
export const PropContext = createContext(null);
